import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './application-security-dev-sec-ops1.css'

const ApplicationSecurityDevSecOps1 = (props) => {
  return (
    <div className="application-security-dev-sec-ops1-container1">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta
          property="og:title"
          content="Application-Security-DevSecOps1 - Well Off Notable Fish"
        />
        <link
          rel="canonical"
          href="https://well-off-notable-fish-gmgkwg.teleporthq.app/application-security-dev-sec-ops1"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-section">
        <video
          src="https://videos.pexels.com/video-files/6963744/6963744-hd_1280_720_25fps.mp4"
          loop="true"
          muted="true"
          poster="https://images.pexels.com/videos/6963744/pictures/preview-0.jpg"
          autoPlay="true"
          playsInline="true"
          className="hero-section__video"
        ></video>
        <div className="hero-section__overlay"></div>
        <div className="hero-section__content">
          <div className="hero-section__text">
            <h1 className="hero-title hero-section__title">
              Application Security &amp; DevSecOps
            </h1>
            <p className="hero-section__subtitle hero-subtitle">
              Integrate security at every stage of your software development
              lifecycle with comprehensive DevSecOps pipeline automation,
              SAST/DAST/SCA analysis, and shift-left security practices that
              reduce vulnerabilities by up to 70% before production.
            </p>
            <div className="hero-section__cta-group">
              
                <a className="btn-primary btn btn-lg" href="https://outlook.office.com/book/CysigilNetwork@cysigil.com/?ismsaljsauthenabled">
                  <span>Talk to an Expert</span>
                </a>
              
              <div className="btn btn-lg btn-outline">
                <span style={{ color: 'black' }}>Request Assessment</span>
                
              </div>
            </div>
            <div className="hero-section__features">
              <div className="hero-section__feature-item">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
                <span>Secure SDLC</span>
              </div>
              <div className="hero-section__feature-item">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="3" y="3" rx="2" width="8" height="8"></rect>
                    <path d="M7 11v4a2 2 0 0 0 2 2h4"></path>
                    <rect x="13" y="13" rx="2" width="8" height="8"></rect>
                  </g>
                </svg>
                <span>CI/CD Integration</span>
              </div>
              <div className="hero-section__feature-item">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m21 21l-4.34-4.34"></path>
                    <circle r="8" cx="11" cy="11"></circle>
                  </g>
                </svg>
                <span>Automated Scanning</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="sdlc-section">
        <div className="sdlc-section__container">
          <div className="sdlc-section__header">
            <h2 className="section-title">
              Secure Software Development Lifecycle
            </h2>
            <p className="section-subtitle">
              Embedding security from requirements through release with proven
              practices and compliance mapping
            </p>
          </div>
          <div className="sdlc-section__timeline">
            <div className="sdlc-section__step">
              <div className="sdlc-section__step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path d="M14 2v5a1 1 0 0 0 1 1h5M9 15l2 2l4-4"></path>
                </svg>
              </div>
              <div className="sdlc-section__step-content">
                <h3 className="sdlc-section__step-title">Requirements</h3>
                <p className="sdlc-section__step-description">
                  Define security requirements, threat modeling, abuse cases,
                  and compliance objectives aligned with NIST, ISO 27001, and
                  OWASP standards.
                </p>
              </div>
              <div className="sdlc-section__connector"></div>
            </div>
            <div className="sdlc-section__step">
              <div className="sdlc-section__step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z"></path>
                    <path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12"></path>
                    <path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17"></path>
                  </g>
                </svg>
              </div>
              <div className="sdlc-section__step-content">
                <h3 className="sdlc-section__step-title">Design</h3>
                <p className="sdlc-section__step-description">
                  Security architecture review, attack surface analysis, data
                  flow diagrams, encryption design, and
                  authentication/authorization frameworks.
                </p>
              </div>
              <div className="sdlc-section__connector"></div>
            </div>
            <div className="sdlc-section__step">
              <div className="sdlc-section__step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="m16 18l6-6l-6-6M8 6l-6 6l6 6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="sdlc-section__step-content">
                <h3 className="sdlc-section__step-title">Implementation</h3>
                <p className="sdlc-section__step-description">
                  Secure coding practices, static code analysis, dependency
                  scanning, IDE security plugins, and pre-commit hooks to catch
                  vulnerabilities early.
                </p>
              </div>
              <div className="sdlc-section__connector"></div>
            </div>
            <div className="sdlc-section__step">
              <div className="sdlc-section__step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m13 13.5l2-2.5l-2-2.5M21 21l-4.3-4.3M9 8.5L7 11l2 2.5"></path>
                    <circle r="8" cx="11" cy="11"></circle>
                  </g>
                </svg>
              </div>
              <div className="sdlc-section__step-content">
                <h3 className="sdlc-section__step-title">Testing</h3>
                <p className="sdlc-section__step-description">
                  Automated SAST/DAST scans, penetration testing, security
                  regression tests, compliance validation, and vulnerability
                  prioritization and remediation tracking.
                </p>
              </div>
              <div className="sdlc-section__connector"></div>
            </div>
            <div className="sdlc-section__step">
              <div className="sdlc-section__step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.4 22.4 0 0 1-4 2"></path>
                    <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0m1 7v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"></path>
                  </g>
                </svg>
              </div>
              <div className="sdlc-section__step-content">
                <h3 className="sdlc-section__step-title">Release</h3>
                <p className="sdlc-section__step-description">
                  Security sign-off gates, production hardening, container
                  security scanning, runtime protection (RASP), and continuous
                  monitoring post-deployment.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="pipeline-section">
        <div className="pipeline-section__container">
          <div className="pipeline-section__header">
            <h2 className="section-title">DevSecOps Pipeline Integration</h2>
            <p className="section-subtitle">
              Seamless security automation across your CI/CD toolchain with
              shift-left architecture patterns
            </p>
          </div>
          <div className="pipeline-section__steps">
            <div className="pipeline-section__step">
              <div className="pipeline-section__step-visual">
                <div className="pipeline-section__step-icon">
                  <svg
                    width="28"
                    xmlns="http://www.w3.org/2000/svg"
                    height="28"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="m16 18l6-6l-6-6M8 6l-6 6l6 6"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
              </div>
              <div className="pipeline-section__step-content">
                <h3 className="pipeline-section__step-title">Source Control</h3>
                <p className="pipeline-section__step-text">
                  Pre-commit hooks with credential scanning, secrets detection,
                  and dependency vulnerability checks integrated with Git,
                  GitHub, GitLab, and Bitbucket.
                </p>
              </div>
              <div className="pipeline-section__step-connector"></div>
            </div>
            <div className="pipeline-section__step">
              <div className="pipeline-section__step-visual">
                <div className="pipeline-section__step-icon">
                  <svg
                    width="28"
                    xmlns="http://www.w3.org/2000/svg"
                    height="28"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0a2.34 2.34 0 0 0 3.319 1.915a2.34 2.34 0 0 1 2.33 4.033a2.34 2.34 0 0 0 0 3.831a2.34 2.34 0 0 1-2.33 4.033a2.34 2.34 0 0 0-3.319 1.915a2.34 2.34 0 0 1-4.659 0a2.34 2.34 0 0 0-3.32-1.915a2.34 2.34 0 0 1-2.33-4.033a2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path>
                      <circle r="3" cx="12" cy="12"></circle>
                    </g>
                  </svg>
                </div>
              </div>
              <div className="pipeline-section__step-content">
                <h3 className="pipeline-section__step-title">Build Stage</h3>
                <p className="pipeline-section__step-text">
                  SAST scanning, software composition analysis, license
                  compliance checks, and security quality gates in Jenkins,
                  CircleCI, Azure DevOps, and GitHub Actions.
                </p>
              </div>
              <div className="pipeline-section__step-connector"></div>
            </div>
            <div className="pipeline-section__step">
              <div className="pipeline-section__step-visual">
                <div className="pipeline-section__step-icon">
                  <svg
                    width="28"
                    xmlns="http://www.w3.org/2000/svg"
                    height="28"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle r="10" cx="12" cy="12"></circle>
                      <circle r="6" cx="12" cy="12"></circle>
                      <circle r="2" cx="12" cy="12"></circle>
                    </g>
                  </svg>
                </div>
              </div>
              <div className="pipeline-section__step-content">
                <h3 className="pipeline-section__step-title">Test Stage</h3>
                <p className="pipeline-section__step-text">
                  DAST scanning against running applications, API security
                  testing, container image scanning, infrastructure-as-code
                  security validation, and penetration test automation.
                </p>
              </div>
              <div className="pipeline-section__step-connector"></div>
            </div>
            <div className="pipeline-section__step">
              <div className="pipeline-section__step-visual">
                <div className="pipeline-section__step-icon">
                  <svg
                    width="28"
                    xmlns="http://www.w3.org/2000/svg"
                    height="28"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      <path d="m9 12l2 2l4-4"></path>
                    </g>
                  </svg>
                </div>
              </div>
              <div className="pipeline-section__step-content">
                <h3 className="pipeline-section__step-title">Deploy Stage</h3>
                <p className="pipeline-section__step-text">
                  Security approval gates, configuration drift detection,
                  runtime protection activation, security monitoring integration
                  with Kubernetes, Docker, AWS, Azure, and GCP.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="analysis-section">
        <div className="analysis-section__container">
          <div className="analysis-section__header">
            <h2 className="section-title">Security Analysis Technologies</h2>
            <p className="section-subtitle">
              Comprehensive coverage across static, dynamic, and composition
              analysis with intelligent prioritization
            </p>
          </div>
          <div className="analysis-section__grid">
            <div className="analysis-section__card">
              <div className="analysis-section__card-icon">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5m-10 4.5L8 15l2 2.5m4-5l2 2.5l-2 2.5"></path>
                  </g>
                </svg>
              </div>
              <h3 className="analysis-section__card-title">
                SAST (Static Application Security Testing)
              </h3>
              <p className="analysis-section__card-description">
                Analyze source code, bytecode, and binaries without execution to
                identify vulnerabilities like SQL injection, XSS, hardcoded
                secrets, and insecure configurations. Tools: SonarQube,
                Checkmarx, Fortify, Semgrep.
              </p>
              <ul className="analysis-section__card-list">
                <li>
                  <span>White-box analysis of code structure</span>
                </li>
                <li>
                  <span>Early detection in development phase</span>
                </li>
                <li>
                  <span>Language-specific security patterns</span>
                </li>
                <li>
                  <span>IDE integration for real-time feedback</span>
                </li>
              </ul>
            </div>
            <div className="analysis-section__card">
              <div className="analysis-section__card-icon">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="analysis-section__card-title">
                DAST (Dynamic Application Security Testing)
              </h3>
              <p className="analysis-section__card-description">
                Test running applications from outside to discover runtime
                vulnerabilities, authentication flaws, session management
                issues, and business logic gaps. Tools: OWASP ZAP, Burp Suite,
                Acunetix, Qualys WAS.
              </p>
              <ul className="analysis-section__card-list">
                <li>
                  <span>Black-box testing of live applications</span>
                </li>
                <li>
                  <span>Real-world attack simulation</span>
                </li>
                <li>
                  <span>API and web application coverage</span>
                </li>
                <li>
                  <span>Zero false positives validation</span>
                </li>
              </ul>
            </div>
            <div className="analysis-section__card">
              <div className="analysis-section__card-icon">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z"></path>
                    <path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12"></path>
                    <path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17"></path>
                  </g>
                </svg>
              </div>
              <h3 className="analysis-section__card-title">
                SCA (Software Composition Analysis)
              </h3>
              <p className="analysis-section__card-description">
                Identify vulnerabilities in open-source and third-party
                components, track license compliance, detect outdated libraries,
                and supply chain risks. Tools: Snyk, BlackDuck, Dependabot,
                WhiteSource.
              </p>
              <ul className="analysis-section__card-list">
                <li>
                  <span>Dependency vulnerability tracking</span>
                </li>
                <li>
                  <span>License compliance monitoring</span>
                </li>
                <li>
                  <span>SBOM (Software Bill of Materials)</span>
                </li>
                <li>
                  <span>Automatic remediation guidance</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="analysis-section__additional">
            <div className="analysis-section__rasp">
              <div className="analysis-section__rasp-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="analysis-section__rasp-content">
                <h3 className="analysis-section__rasp-title">
                  RASP (Runtime Application Self-Protection)
                </h3>
                <p className="analysis-section__rasp-text">
                  Real-time protection embedded within applications to detect
                  and block attacks during execution, providing context-aware
                  security that adapts to application behavior and threat
                  patterns.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="2-5-application-security---devsecops-services-section">
        <div className="services-section__container">
          <div className="services-section__header">
            <h2 className="section-title">Our DevSecOps Service Offerings</h2>
            <p className="section-subtitle">
              End-to-end support from tool selection through ongoing
              optimization and managed services
            </p>
          </div>
          <div className="services-section__grid">
            <div className="services-section__card">
              <div className="services-section__card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="3" y="3" rx="2" width="8" height="8"></rect>
                    <path d="M7 11v4a2 2 0 0 0 2 2h4"></path>
                    <rect x="13" y="13" rx="2" width="8" height="8"></rect>
                  </g>
                </svg>
              </div>
              <h3 className="services-section__card-title">
                Tool Onboarding &amp; Integration
              </h3>
              <p className="services-section__card-description">
                Select, deploy, and integrate best-of-breed security tools into
                your existing CI/CD pipelines with minimal disruption to
                development workflows and time-to-market.
              </p>
            </div>
            <div className="services-section__card">
              <div className="services-section__card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0a2.34 2.34 0 0 0 3.319 1.915a2.34 2.34 0 0 1 2.33 4.033a2.34 2.34 0 0 0 0 3.831a2.34 2.34 0 0 1-2.33 4.033a2.34 2.34 0 0 0-3.319 1.915a2.34 2.34 0 0 1-4.659 0a2.34 2.34 0 0 0-3.32-1.915a2.34 2.34 0 0 1-2.33-4.033a2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path>
                    <circle r="3" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="services-section__card-title">
                Security Policy &amp; Rule Tuning
              </h3>
              <p className="services-section__card-description">
                Customize scanning policies, reduce false positives, configure
                vulnerability thresholds, and align security gates with your
                risk tolerance and compliance requirements.
              </p>
            </div>
            <div className="services-section__card">
              <div className="services-section__card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5m-10 4.5L8 15l2 2.5m4-5l2 2.5l-2 2.5"></path>
                  </g>
                </svg>
              </div>
              <h3 className="services-section__card-title">
                CI/CD Plugins &amp; Automation
              </h3>
              <p className="services-section__card-description">
                Deploy security plugins for Jenkins, GitLab CI, GitHub Actions,
                Azure Pipelines, and CircleCI with automated reporting, Jira
                integration, and Slack notifications.
              </p>
            </div>
            <div className="services-section__card">
              <div className="services-section__card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="m16 18l6-6l-6-6M8 6l-6 6l6 6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="services-section__card-title">
                Pipeline-as-Code Implementation
              </h3>
              <p className="services-section__card-description">
                Define infrastructure, security policies, and pipeline
                configurations as version-controlled code using Terraform,
                Ansible, and declarative pipeline syntax for repeatability.
              </p>
            </div>
            <div className="services-section__card">
              <div className="services-section__card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m21 21l-4.34-4.34"></path>
                    <circle r="8" cx="11" cy="11"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="services-section__card-title">
                Managed Scanning Services
              </h3>
              <p className="services-section__card-description">
                Outsource security scanning operations with 24/7 monitoring,
                scheduled scans, vulnerability triage, remediation guidance, and
                executive reporting dashboards.
              </p>
            </div>
            <div className="services-section__card">
              <div className="services-section__card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                    <path d="m19 9l-5 5l-4-4l-3 3"></path>
                  </g>
                </svg>
              </div>
              <h3 className="services-section__card-title">
                Metrics &amp; Continuous Improvement
              </h3>
              <p className="services-section__card-description">
                Track security KPIs (vulnerability trends, MTTR, scanning
                coverage), benchmark against industry standards, and optimize
                processes based on data-driven insights.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="roadmap-section">
        <div className="application-security-dev-sec-ops1-thq-roadmap-sectionbg-image-elm roadmap-section__bg-image"></div>
        <div className="roadmap-section__overlay"></div>
        <div className="roadmap-section__content">
          <div className="roadmap-section__header">
            <h2 className="section-title">Implementation Roadmap</h2>
            <p className="section-subtitle">
              Phased approach to DevSecOps transformation with clear
              deliverables and measurable outcomes
            </p>
          </div>
          <div className="roadmap-section__timeline">
            <div className="roadmap-section__phase">
              <div className="roadmap-section__phase-number">
                <span>01</span>
              </div>
              <div className="roadmap-section__phase-content">
                <h3 className="roadmap-section__phase-title">
                  Assessment &amp; Planning
                </h3>
                <p className="roadmap-section__phase-duration">2-3 Weeks</p>
                <p className="roadmap-section__phase-description">
                  Audit current SDLC, toolchain analysis, threat modeling, risk
                  assessment, and roadmap creation aligned with business
                  objectives.
                </p>
                <div className="roadmap-section__phase-deliverables">
                  <span className="roadmap-section__phase-tag">
                    Gap Analysis Report
                  </span>
                  <span className="roadmap-section__phase-tag">
                    Tool Recommendations
                  </span>
                  <span className="roadmap-section__phase-tag">
                    Implementation Plan
                  </span>
                </div>
              </div>
            </div>
            <div className="roadmap-section__phase">
              <div className="roadmap-section__phase-number">
                <span>02</span>
              </div>
              <div className="roadmap-section__phase-content">
                <h3 className="roadmap-section__phase-title">
                  Pilot &amp; Integration
                </h3>
                <p className="roadmap-section__phase-duration">3-4 Weeks</p>
                <p className="roadmap-section__phase-description">
                  Deploy security tools in non-production environments,
                  configure scanning policies, integrate with CI/CD, and
                  validate with pilot projects.
                </p>
                <div className="roadmap-section__phase-deliverables">
                  <span className="roadmap-section__phase-tag">
                    Tool Configuration
                  </span>
                  <span className="roadmap-section__phase-tag">
                    Pipeline Integration
                  </span>
                  <span className="roadmap-section__phase-tag">
                    Pilot Results
                  </span>
                </div>
              </div>
            </div>
            <div className="roadmap-section__phase">
              <div className="roadmap-section__phase-number">
                <span>03</span>
              </div>
              <div className="roadmap-section__phase-content">
                <h3 className="roadmap-section__phase-title">
                  Rollout &amp; Optimization
                </h3>
                <p className="roadmap-section__phase-duration">4-6 Weeks</p>
                <p className="roadmap-section__phase-description">
                  Expand to all projects, fine-tune policies to reduce noise,
                  implement security gates, and establish vulnerability
                  management workflows.
                </p>
                <div className="roadmap-section__phase-deliverables">
                  <span className="roadmap-section__phase-tag">
                    Full Deployment
                  </span>
                  <span className="roadmap-section__phase-tag">
                    Policy Tuning
                  </span>
                  <span className="roadmap-section__phase-tag">
                    Workflow Documentation
                  </span>
                </div>
              </div>
            </div>
            <div className="roadmap-section__phase">
              <div className="roadmap-section__phase-number">
                <span>04</span>
              </div>
              <div className="roadmap-section__phase-content">
                <h3 className="roadmap-section__phase-title">
                  Training &amp; Enablement
                </h3>
                <p className="roadmap-section__phase-duration">2-3 Weeks</p>
                <p className="roadmap-section__phase-description">
                  Developer workshops on secure coding, tool training, runbook
                  creation, and establishment of security champions program
                  within teams.
                </p>
                <div className="roadmap-section__phase-deliverables">
                  <span className="roadmap-section__phase-tag">
                    Training Materials
                  </span>
                  <span className="roadmap-section__phase-tag">Runbooks</span>
                  <span className="roadmap-section__phase-tag">
                    Champions Program
                  </span>
                </div>
              </div>
            </div>
            <div className="roadmap-section__phase">
              <div className="roadmap-section__phase-number">
                <span>05</span>
              </div>
              <div className="roadmap-section__phase-content">
                <h3 className="roadmap-section__phase-title">
                  Measurement &amp; Maturity
                </h3>
                <p className="roadmap-section__phase-duration">Ongoing</p>
                <p className="roadmap-section__phase-description">
                  Establish KPI dashboards, quarterly security reviews,
                  continuous optimization, and maturity assessment against
                  frameworks like OWASP SAMM and BSIMM.
                </p>
                <div className="roadmap-section__phase-deliverables">
                  <span className="roadmap-section__phase-tag">
                    KPI Dashboard
                  </span>
                  <span className="roadmap-section__phase-tag">
                    Maturity Scorecard
                  </span>
                  <span className="roadmap-section__phase-tag">
                    Improvement Roadmap
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="roadmap-section__metrics">
            <div className="roadmap-section__metric">
              <div className="roadmap-section__metric-value">
                <span>70%</span>
              </div>
              <div className="roadmap-section__metric-label">
                <span>Reduction in Production Vulnerabilities</span>
              </div>
            </div>
            <div className="roadmap-section__metric">
              <div className="roadmap-section__metric-value">
                <span>85%</span>
              </div>
              <div className="roadmap-section__metric-label">
                <span>Faster Vulnerability Remediation</span>
              </div>
            </div>
            <div className="roadmap-section__metric">
              <div className="roadmap-section__metric-value">
                <span>60%</span>
              </div>
              <div className="roadmap-section__metric-label">
                <span>Cost Savings vs Manual Testing</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="application-security-dev-sec-ops1-container2">
        <div className="application-security-dev-sec-ops1-container3">
          <Script
            html={`<script defer data-name="scroll-animations">
(function(){
const observerOptions = {
  threshold: 0.1,
  rootMargin: '0px 0px -50px 0px'
};

const animateOnScroll = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.style.opacity = '1';
      entry.target.style.transform = 'translateY(0)';
    }
  });
}, observerOptions);

const elementsToAnimate = document.querySelectorAll(
  '.sdlc-section__step, .pipeline-section__step, .analysis-section__card, .services-section__card, .roadmap-section__phase, .casestudies-section__card'
);

elementsToAnimate.forEach(el => {
  el.style.opacity = '0';
  el.style.transform = 'translateY(20px)';
  el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
  animateOnScroll.observe(el);
});

if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  elementsToAnimate.forEach(el => {
    el.style.opacity = '1';
    el.style.transform = 'none';
    el.style.transition = 'none';
  });
}
})()
</script>`}
          ></Script>
        </div>
      </div>
      <section className="application-security-dev-sec-ops1-thq-cta-section-elm cta-section firewall-configuration-review-cta-section">
        <div className="cta-wrapper firewall-configuration-review-cta-wrapper">
          <div className="cta-content-block">
            <div className="cta-icon-feature">
              <svg
                width="48"
                xmlns="http://www.w3.org/2000/svg"
                height="48"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12l2 2l4-4"></path>
                </g>
              </svg>
            </div>
            <h2 className="section-title">Start Your DevSecOps Journey</h2>
            <p className="section-content">
              Transform your software development lifecycle with integrated
              security that accelerates delivery while reducing risk. Our
              experts will assess your current state and design a customized
              roadmap.
            </p>
          </div>
          <div className="application-security-dev-sec-ops1-thq-cta-action-block-elm cta-action-block">
            <div className="firewall-configuration-review-cta-card">
              <h3 className="firewall-configuration-review-cta-card-title">
                Request Assessment
              </h3>
              <p className="firewall-configuration-review-cta-card-description">
                Get a Devsecops Implementaion roadmap.
              </p>
              <a href="#assessment">
                <div className="btn btn-lg btn-secondary">
                  <span>Request Assessment</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <Footer></Footer>
    </div>
  )
}

export default ApplicationSecurityDevSecOps1
